'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;
//import SVGMorpheus from 'svg-morpheus';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _config = require('../../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('components');

var _header = require('./header.scss');

var _header2 = _interopRequireDefault(_header);

var _overflowBody = require('redux/modules/overflowBody');

var overflowBodyActions = _interopRequireWildcard(_overflowBody);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    overflowBody: state.overflowBody.overflowBody,
    positionScroll: state.scroll.positionScroll
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)((0, _extends3.default)({}, overflowBodyActions), dispatch);
}, null, {}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header(props, context) {
    (0, _classCallCheck3.default)(this, Header);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props, context));

    _this.handleClose = function () {
      _this.setState({
        menuBurguerShow: false,
        menuBurguerSimple: false
      }, function () {
        _this.props.setOverflowBody(true);
        $("html, body").animate({ scrollTop: 0 }, "slow");
      });
    };

    _this.state = {
      menuBurguerShow: false,
      menuFixedTimerHide: true,
      menuBurguerSimple: false
    };
    return _this;
  }

  (0, _createClass3.default)(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      //let podcastsLinks = this.props.strings.menuLinks
      // this.myIcons = new SVGMorpheus('#icon');
      setTimeout(function () {
        _this2.setState({ menuFixedTimerHide: false });
      }, 500);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          strings = _props.strings,
          customClass = _props.customClass;

      // const containerClass = classNames({
      //   [customClass]: (customClass) ? true : false,
      //   'headerApp--menuShow': this.state.menuBurguerShow,
      // });

      var containerHeaderClass = (0, _classnames2.default)({
        'header': true
      });

      var logo = (0, _classnames2.default)({
        'headerContainer__logo-lab': true,
        'headerContainer__logo-lab--dark': this.props.positionScroll > 1
      });

      var headerMenu = null;
      if (strings.links) {
        headerMenu = _react2.default.createElement(
          'div',
          { className: 'container headerMenu--container' },
          _react2.default.createElement(_components.HeaderMenu, { strings: strings.links, handleClickLink: this.handleClose, location: location })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: containerHeaderClass },
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'div',
            { className: 'headerContainer' },
            _react2.default.createElement(
              'a',
              { className: logo, href: 'http://www.rtve.es/lab/', target: '_blank', title: 'Ir a Lab RTVE' },
              _react2.default.createElement('span', { className: 'headerContainer__logo-lab__icon icon-logo-lab', 'aria-hidden': 'true' })
            )
          )
        )
      );
    }
  }]);
  return Header;
}(_react.Component), _class2.displayName = 'Header', _class2.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  project: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = Header;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Header/Header.jsx
// module id = 702
// module chunks = 0